import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const GoogleCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser, setBusiness } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const errorParam = searchParams.get('error');

        if (errorParam) {
          console.error('Google OAuth error:', errorParam);
          navigate('/login', { 
            replace: true, 
            state: { error: 'Google sign-in was cancelled or failed.' } 
          });
          return;
        }

        if (!code) {
          console.error('No authorization code received');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange code for session
        const response = await axios.post(
          `${API}/auth/google/callback`,
          { code },
          { withCredentials: true }
        );

        if (response.data.success) {
          setUser(response.data.user);
          setBusiness(response.data.business);

          // Redirect based on account type
          const accountType = response.data.user?.account_type;
          if (accountType === 'business' && response.data.business) {
            navigate('/business/dashboard', { replace: true });
          } else {
            navigate('/', { replace: true });
          }
        } else {
          throw new Error('Authentication failed');
        }
      } catch (err) {
        console.error('Google callback error:', err);
        setError(err.response?.data?.detail || 'Authentication failed');
        setTimeout(() => {
          navigate('/login', { 
            replace: true, 
            state: { error: 'Google sign-in failed. Please try again.' } 
          });
        }, 2000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, setUser, setBusiness]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-red-400 text-lg mb-2">{error}</p>
            <p className="text-gray-400 text-sm">Redirecting to login...</p>
          </>
        ) : (
          <>
            <Loader2 className="h-12 w-12 animate-spin text-yellow-500 mx-auto mb-4" />
            <p className="text-white text-lg">Completing sign in...</p>
            <p className="text-gray-400 text-sm mt-2">Please wait while we verify your account</p>
          </>
        )}
      </div>
    </div>
  );
};

export default GoogleCallback;
